import axios from "axios";
import store from "./index";

// const baseUrl = "http://localhost:8000/";
const baseUrl = "https://gisoon.negahgroup.ir/API/";

function getAPIkey() {
    return store.getters["apiKey/get"];
}

export async function post(url, data) {
    const apiKey = getAPIkey();

    let header = {
        'Content-Type': 'application/json',
    };
    if (apiKey != null) {
        header = {
            'Content-Type': 'application/json',
            'api-key': apiKey
        }
    }

    return await axios.post(baseUrl + url, data, {headers: header});
}

export async function get(url) {
    const apiKey = getAPIkey();
    const platform = '&platform=web'

    let header = '';
    if (apiKey != null) {
        header = {'api-key': apiKey}
    }

    return await axios.get(baseUrl + url + platform, {headers: header});
}

export async function recaptchChek(token) {
    let url = "https://gisoon.negahgroup.ir/googlePlay/recaptcha.php";
    let data = {token: token}
    return await axios.post(url, data);
}